<template>
  <a-form
    :form="form"
    layout="inline"
    class="ocpc-filter-form"
    @submit.prevent="formHandle"
  >
    <a-form-item>
      <a-input
        v-decorator="[
          'searchvalue'
          ,
          { initialValue: selectInputData.searchvalue }
        ]"
        :placeholder="placeholderTxt"
        style="width:420px;"
      >
        <a-select
          slot="addonBefore"
          v-decorator="[
            'searchtype',
            { initialValue: selectInputData.searchtype }
          ]"
          style="width: 100px"
          @change="selectHandle"
        >
          <a-select-option
            v-for="item in selectOptions"
            :key="item.value"
            :value="item.value"
          >
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-input>
    </a-form-item>
    <a-form-item>
      <a-button
        type="primary"
        html-type="submit"
      >
        {{ $t('message["91"]') }}
      </a-button>
      <a-button
        html-type="reset"
        @click="resetHandle"
      >
        {{ $t('message["896"]') }}
      </a-button>
    </a-form-item>
  </a-form>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  data () {
    return {
      form: this.$form.createForm(this),
      selectInputData: {
        searchtype: 1,
        searchvalue: ''
      },
      selectOptions: [
        {
          value: 1,
          label: this.$t('message["1831"]')
        },
        {
          value: 2,
          label: this.$t('message["1832"]')
        }
      ],
      placeholderTxt: this.$t('message["1833"]')
    }
  },
  computed: {
  },
  methods: {
    ...mapActions('config/ocpc', ['getOcpcRecordListDatas']),
    formHandle () {
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          this.$emit('filterHandle', values)
        }
      })
    },
    selectHandle (val) {
      this.placeholderTxt = val === 1 ? this.$t('message["1833"]') : this.$t('message["1834"]')
    },
    async resetHandle () {
      this.$emit('filterHandle')
      this.form.setFieldsValue({
        searchtype: 1,
        searchvalue: ''
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.ocpc-filter-form {
  margin: 8px 0 24px;
}
</style>
